import _ from 'underscore';
import { addColumnOnLevel } from '../add-column-on-level';
import { absoluteTopImpressionRate, topImpressionRate } from '../shared/columns';

export function getlandingGridColumnConfig({ i18n, bingadsGridColumn, globalConfig }) {
  const {
    IsViewThroughConversionEnabled,
    IsAvgPositionDeprecationPhase1Enabled,
    IsAvgPositionDeprecationPhase2Enabled,
    dynamic = {},
    // IsViewThroughConversionsRevenueEnabled,
  } = globalConfig.get('Permissions') || {};
  // (youngim) MT bug needs to be fixed for dimensinos
  const IsViewThroughConversionsRevenueEnabled = false;

  const {
    PartialConversions: IsPartialConversionsEnabled,
    ColumnConversion: IsColumnConversionEnabled,
  } = dynamic;

  const usePartialConversions = IsPartialConversionsEnabled && IsColumnConversionEnabled;

  function column(options) {
    return bingadsGridColumn(_.defaults({}, options, { i18n }));
  }

  return {
    getLevelOfDetailColumns: (level) => {
      const levelOfDetailColumns = [];

      levelOfDetailColumns.push(column({
        name: 'KeywordDestinationUrl',
        title: 'ColumnName_DimKeywordDestinationUrl',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_CampaignGrids_DestinationURL',
      }));
      levelOfDetailColumns.push(column({
        name: 'FinalUrl',
        title: 'ColumnName_DimFinalUrl',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_FinalURL',
      }));
      levelOfDetailColumns.push(column({
        name: 'UrlCustomParameters',
        title: 'ColumnName_DimUrlCustomParameters',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_CustomParameters',
      }));
      levelOfDetailColumns.push(column({
        name: 'TrackingTemplate',
        title: 'ColumnName_TrackingTemplate',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_TrackingTemplate',
      }));
      levelOfDetailColumns.push(column({
        name: 'FinalUrlSuffix',
        title: 'ColumnName_FinalUrlSuffix',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_NewAdCreate_FinalURLSuffix',
      }));

      addColumnOnLevel(column, levelOfDetailColumns, level);

      return levelOfDetailColumns;
    },
    getPerfColumns: () => _.compact([
      column({
        name: 'Impressions',
        title: 'ColumnName_Impressions',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_CampaignGrids_Impr',
      }),
      column({
        name: 'Clicks',
        title: 'ColumnName_Clicks',
        sortable: true,
        type: 'number',
        format: 'integer',
        helpId: 'pop_BA_CampaignGrids_Clicks',
      }),
      column({
        name: 'CTR',
        title: 'ColumnName_ClickThruRate',
        sortable: true,
        type: 'number',
        format: 'percentage-value',
        helpId: 'pop_BA_CampaignGrids_CTR',
      }),
      column({
        name: 'AverageCPC',
        title: 'ColumnName_AverageCPC',
        sortable: true,
        type: 'number',
        helpId: 'pop_BA_CampaignGrids_AvgCPC',
      }),
      column({
        name: 'AverageCPM',
        title: 'ColumnName_AverageCPM',
        sortable: true,
        type: 'number',
        helpId: 'Page_CampaignGrids_AvgCPM',
      }),
      column({
        name: 'Spend',
        title: 'ColumnName_Spend',
        sortable: true,
        type: 'number',
        helpId: 'pop_BA_CampaignGrids_Spend',
      }),
      !IsAvgPositionDeprecationPhase2Enabled && column({
        name: 'AveragePosition',
        title: 'ColumnName_AveragePosition',
        sortable: true,
        type: 'number',
        helpId: 'pop_BA_CampaignGrids_AvgPosition',
      }),
      IsAvgPositionDeprecationPhase1Enabled && column(topImpressionRate),
      IsAvgPositionDeprecationPhase1Enabled && column(absoluteTopImpressionRate),
    ]),
    getConversionColumns: () => {
      let conversionColumns = [
        usePartialConversions ?
          column({
            name: 'ConversionsCredit',
            title: 'ColumnName_Conversions',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_Conv',
          }) : column({
            name: 'Conversions',
            title: 'ColumnName_Conversions',
            sortable: true,
            type: 'number',
            format: 'integer',
            helpId: 'pop_BA_CampaignGrids_Conv',
          }),
        usePartialConversions ?
          column({
            name: 'PartialConversionRate',
            title: 'ColumnName_ConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'pop_BA_CampaignGrids_ConvRate',
          }) : column({
            name: 'ConversionRate',
            title: 'ColumnName_ConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'pop_BA_CampaignGrids_ConvRate',
          }),
        usePartialConversions ?
          column({
            name: 'PartialConversionCPA',
            title: 'ColumnName_CPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'Page_Reporting_Clarity_CPA',
          }) : column({
            name: 'CPA',
            title: 'ColumnName_CPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'Page_Reporting_Clarity_CPA',
          }),
        column({
          name: 'RevenueOnAdSpend',
          title: 'ColumnName_RevenueOnAdSpend',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'Page_CampaignGrids_ReturnAdSpend',
        }),
        column({
          name: 'AdvertiserReportedRevenue',
          title: 'ColumnName_Revenue',
          sortable: true,
          type: 'number',
          helpId: 'Page_CampaignGrids_Revenue',
        }),
        usePartialConversions ?
          column({
            name: 'AllConversionsCredit',
            title: 'ColumnName_AllConversions',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConv',
          }) : column({
            name: 'AllConversions',
            title: 'ColumnName_AllConversions',
            sortable: true,
            type: 'number',
            format: 'integer',
            helpId: 'pop_BA_CampaignGrids_AllConv',
          }),
        usePartialConversions ?
          column({
            name: 'AllPartialConversionCPA',
            title: 'ColumnName_AllConversionCPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConvCPA',
          }) :
          column({
            name: 'AllConversionCPA',
            title: 'ColumnName_AllConversionCPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConvCPA',
          }),
        usePartialConversions ? column({
          name: 'AllPartialConversionRate',
          title: 'ColumnName_AllConversionRate',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_CampaignGrids_AllConvRate',
        }) :
          column({
            name: 'AllConversionRate',
            title: 'ColumnName_AllConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'pop_BA_CampaignGrids_AllConvRate',
          }),
        column({
          name: 'AllConversionAdvertiserReportedRevenue',
          title: 'ColumnName_AllConversionAdvertiserReportedRevenue',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_CampaignGrids_AllConvRevenue',
        }),
        column({
          name: 'AllConversionRevenueOnAdSpend',
          title: 'ColumnName_AllConversionRevenueOnAdSpend',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_CampaignGrids_AllConvROAS',
        }),
      ];

      if (IsViewThroughConversionEnabled) {
        conversionColumns = conversionColumns.concat([
          usePartialConversions ?
            column({
              name: 'ViewThroughConversionsCredit',
              title: 'ColumnName_ViewThroughConversions',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_CampaignGrids_ViewThrough',
              format: 'decimal',
            }) :
            column({
              name: 'ViewThroughConversions',
              title: 'ColumnName_ViewThroughConversions',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_CampaignGrids_ViewThrough',
              format: 'integer',
            }),
        ]);
      }


      if (IsViewThroughConversionsRevenueEnabled) {
        conversionColumns = conversionColumns.concat([
          column({
            name: 'ViewThroughConversionsRevenue',
            title: 'ColumnName_ViewThroughConversionsRevenue',
            sortable: true,
            type: 'number',
            helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRevenue',
            format: 'decimal',
          }),
          usePartialConversions ?
            column({
              name: 'ViewThroughPartialConversionsCPA',
              title: 'ColumnName_ViewThroughConversionsCPA',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
              format: 'decimal',
            }) :
            column({
              name: 'ViewThroughConversionsCPA',
              title: 'ColumnName_ViewThroughConversionsCPA',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
              format: 'decimal',
            }),
          column({
            name: 'ViewThroughConversionsReturnOnAdSpend',
            title: 'ColumnName_ViewThroughConversionsReturnOnAdSpend',
            sortable: true,
            type: 'number',
            helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvReturnOnAdSpend',
            format: 'percentage-value',
          }),
          usePartialConversions ?
            column({
              name: 'ViewThroughPartialConversionsRate',
              title: 'ColumnName_ViewThroughConversionsRate',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
              format: 'percentage-value',
            }) :
            column({
              name: 'ViewThroughConversionsRate',
              title: 'ColumnName_ViewThroughConversionsRate',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
              format: 'percentage-value',
            }),
        ]);
      }

      return conversionColumns;
    },
  };
}
